import { createAction, props } from '@ngrx/store';
import { UserFilterWithPagination } from 'src/app/models/request-models/user-filter-with-pagination-request';

export enum ActionTypes {
  GET_ALL_USERS = '[Users] Get All Users',
  GET_ALL_USERS_SUCCESS = '[Users] Get All Users Success',
  GET_ALL_USERS_FAILURE = '[Users] Get All Users Failure',
}

export const getAllUsers = createAction(
  ActionTypes.GET_ALL_USERS,
  props<{ data: Partial<UserFilterWithPagination> }>(),
);

export const getAllUsersSuccess = createAction(ActionTypes.GET_ALL_USERS_SUCCESS, props<{ data: any }>());

export const getAllUsersFailure = createAction(ActionTypes.GET_ALL_USERS_FAILURE, props<{ error: any }>());
